import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import BackComponent from "../BackComponent";

import { UserContext } from "../userComponents/UserContext";

const SingleEditMovieComponent = () => {
  let { id } = useParams();
  const [user] = useContext(UserContext);
  const [data, setData] = useState(null);
  const history = useHistory();

  useEffect(() => {
    if (data === null) {
      axios
        .get(`https://backendexample.sanbersy.com/api/data-movie/${id}`)
        .then((res) => {
          setData(res.data);
        });
    }
  }, [data, setData, id]);
  console.log(user);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(
        `https://backendexample.sanbersy.com/api/data-movie/${id}`,

        {
          title: data.title,
          description: data.description,
          year: data.year,
          rating: data.rating,
          genre: data.genre,
          duration: data.duration,
          review: data.review,
          image_url: data.image_url,
        },
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      )
      .then((res) => {
        history.push("/movies");
        console.log(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setData((beforeValue) => ({
      ...beforeValue,
      [id]: value,
    }));
    console.log([id]);
  };

  return (
    <Container>
      <Row>
        <Col md="8" className="mx-auto mt-5">
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Title :</Label>
              <Input
                type="text"
                id="title"
                placeholder="Input Title"
                onChange={handleChange}
                value={data !== null && data.title}
              />
            </FormGroup>
            <FormGroup>
              <Label>Description :</Label>
              <Input
                type="text"
                id="description"
                placeholder="Input Description"
                onChange={handleChange}
                value={data !== null && data.description}
              />
            </FormGroup>
            <FormGroup>
              <Label>Genre :</Label>
              <Input
                type="text"
                id="genre"
                placeholder="Input Genre"
                onChange={handleChange}
                value={data !== null && data.genre}
              />
            </FormGroup>
            <FormGroup>
              <Label>Year :</Label>
              <Input
                type="number"
                id="year"
                placeholder="Input Year"
                onChange={handleChange}
                value={data !== null && data.year}
              />
            </FormGroup>
            <FormGroup>
              <Label>Duration :</Label>
              <Input
                type="number"
                id="duration"
                placeholder="Input Duration"
                onChange={handleChange}
                value={data !== null && data.duration}
              />
            </FormGroup>
            <FormGroup>
              <Label>Rating :</Label>
              <Input
                type="number"
                id="rating"
                placeholder="Input Rating"
                onChange={handleChange}
                value={data !== null && data.rating}
              />
            </FormGroup>
            <FormGroup>
              <Label>Review :</Label>
              <Input
                type="text"
                id="review"
                placeholder="Input Review"
                onChange={handleChange}
                value={data !== null && data.review}
              />
            </FormGroup>
            <FormGroup>
              <Label>Image Url :</Label>
              <Input
                type="text"
                id="image_url"
                placeholder="Input Image_Url"
                onChange={handleChange}
                value={data !== null && data.image_url}
              />
            </FormGroup>
            <Button type="submit" className="primary mb-2">
              Submit
            </Button>
            <BackComponent />
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default SingleEditMovieComponent;
